import React, { useRef } from "react";
import { Navigation, Thumbs, FreeMode, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import useWindowSize from "@/hooks/useWindowSize";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import breakpoints from "@/constants/breakpoinst";

export default function Slider({ slides = [] }) {
  const windowSize = useWindowSize();

  return (
    <Swiper
      slidesPerView={1.3}
      slidesPerGroup={2}
      spaceBetween={16}
      threshold={10}
      modules={[Thumbs, Navigation, FreeMode]}
      freeMode={windowSize.width < breakpoints.lg}
      navigation={{
        enabled: true,
        hiddenClass: "hidden",
        disabledClass: "text-neutral-50 border-neutral-50",
      }}
    >
      {slides.map((slide, i) => (
        <SwiperSlide key={i}>
          <div className="h-auto  w-full">{slide}</div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export function CardSlider({ slides = [] }) {
  const paginationRef = useRef(null);
  const windowSize = useWindowSize();

  return (
    <Swiper
      slidesPerView={1}
      breakpoints={{
        [breakpoints.xl]: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 24,
        },
        [breakpoints.lg]: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 24,
        },
        [breakpoints.md]: {
          slidesPerView: 3.2,
          slidesPerGroup: 3,
          spaceBetween: 24,
        },
        [breakpoints.sm]: {
          slidesPerView: 1.5,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
      }}
      modules={[Thumbs, Navigation, Pagination]}
      pagination={{
        clickable: true,
        type: "bullets",
        el: paginationRef.current,
        currentClass: "bg-neutral-900",

        bulletClass: "block w-6 h-1 bg-neutral-50 ",
        bulletActiveClass: "bg-neutral-900",
      }}
      navigation={{
        hiddenClass: "hidden",
        disabledClass: "text-neutral-50 border-neutral-50",
      }}
    >
      {slides.map((slide, i) => (
        <SwiperSlide key={i}>
          <div className="h-auto  w-full">{slide}</div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
